import Types from "components/editor_canvas/editor_canvas_element_types";

const {detect} = require('detect-browser');
const browser = detect();

class MBackground {
    static type = 'background';
    type = MBackground.type;

    constructor(i) {
        this.img = require('assets/editor/backgrounds/' + i + '.jpg');
        this.thumb = require('assets/editor/backgrounds/thumbs/' + i + '.jpg');
        this.i = i;
    }
}

class MObject {
    static type = 'object';
    type = MObject.type;
    ext = '.webp';

    constructor(i) {
        if (browser && browser.name === 'safari') {
            this.ext = '.png'
        }
        this.img = require('assets/editor/objects/' + i + this.ext);
        // this.pngImg = require('assets/editor/objects/png/' + i + '.png');
        this.thumb = require('assets/editor/objects/thumbs/' + i + this.ext);
        this.i = i;
    }
}

class MCharacter {
    static type = 'character';
    type = MObject.type;
    ext = '.webp';

    constructor(i) {
        if (browser && browser.name === 'safari') {
            this.ext = '.png'
        }
        this.img = require('assets/editor/characters/' + i + this.ext);
        // this.pngImg = require('assets/editor/characters/png/' + i + '.png');
        this.thumb = require('assets/editor/characters/thumbs/' + i + this.ext);
        this.i = i;
    }
}

class MTextbox {
    static type = 'textbox';
    type = MObject.type;
    ext = '.webp';

    constructor(i) {
        if (browser && browser.name === 'safari') {
            this.ext = '.png'
        }
        this.img = require('assets/editor/textboxes/' + i + this.ext);
        this.shapeLeft = require('assets/editor/textboxes/' + i + '_shape_l' + this.ext);
        this.shapeRight = require('assets/editor/textboxes/' + i + '_shape_r' + this.ext);
        this.thumb = require('assets/editor/textboxes/thumbs/' + i + this.ext);
        this.i = i;
    }
}

export class MAsset {
    static get(placeditem) {
        let i = placeditem.asset;
        switch (placeditem.type) {
            case Types.PLACED_OBJECT:
                return objects[i];
            case Types.PLACED_TEXTBOX:
                return textBoxes[i];
            case Types.PLACED_CHARACTER:
                return characters[i];
            case Types.PLACED_TEXTBOX_FULLSCREEN:
                let ext = '.webp';
                if (browser && browser.name === 'safari') {
                    ext = '.png';
                }
                return {img: require('assets/editor/textboxes/thumbs/' + i + ext)};
            default:
                return null;
        }
    }
}

const preloaded = {};

export function preloadImage(url) {
    if (!!preloaded[url]) {
        return;
    }
    preloaded[url] = true;
    var img = new Image();
    img.src = url;
}

export const backgrounds = [...Array(130).keys()].map(i => new MBackground(i));
export const objects = [...Array(236).keys()].map(i => new MObject(i));
export const characters = [...Array(690).keys()].map(i => new MCharacter(i));
export const textBoxes = [...Array(26).keys()].map(i => new MTextbox(i));
export const fullTextBoxes = {
    right: 'right',
    left: 'left',
};

export const hiddenTextboxes = new Set([
    0, 10, 11, 20, 22, 23, 24, 25, 26
]);

export const objectsOrdering = [
    // accessories
    28, 3, 25, 38, 39, 63, 64, 70, 75, 79, 82, 93, 100, 114, 115, 133, 136, 140, 149, 151, 153, 159, 160, 166, 200, 214, 222, 226, 227,
    // animals
    6, 12, 14, 17, 24, 62, 87, 88, 141, 142, 143, 174, 202,
    // bags
    10, 40, 47, 48, 56, 73, 77, 81, 85, 95, 96, 146, 147, 148, 175, 183, 184, 218, 223, 224,
    // balls
    16, 32, 61, 74, 92, 94, 122, 123, 124, 132, 134, 155, 170, 181, 186, 189, 194, 217,
    // camping
    20, 23, 69, 198, 215, 221,
    // clocks
    31, 50, 60, 97, 171, 234, 235,
    // clothes
    162, 163, 164, 208,
    // food
    8, 41, 44, 49, 53, 66, 67, 72, 83, 84, 130, 137, 139, 157, 172, 182, 191, 192, 205, 213, 225, 230, 231,
    // furniture
    19, 105, 118, 127, 144, 145,
    // headphones
    80, 89, 90, 104, 199, 206,
    // plants
    2, 7, 15, 18, 21, 26, 27, 71, 101, 102, 103, 161, 203, 204, 209, 219, 220, 228, 229,
    // school
    0, 1, 9, 22, 29, 33, 34, 35, 36, 42, 43, 46, 52, 54, 59, 106, 107, 108, 109, 110, 111, 112, 113, 116, 117, 125, 129, 135, 138, 150, 154, 167, 168, 193, 195, 201, 207, 210, 211, 212,
    // tech
    5, 30, 37, 45, 51, 65, 68, 76, 78, 91, 98, 99, 128, 152, 156, 165, 178, 179, 180, 190, 196, 232, 233,
    // transport
    4, 11, 13, 55, 57, 58, 86, 119, 120, 121, 126, 131, 158, 169, 173, 176, 177, 185, 187, 188, 197, 216
];